module.exports = __webpack_public_path__ + "img/34.4c874153.jpg";